"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = '/content/api/v4/landing-pages';
var LANGUAGE_CONTENT_URL = 'content/api/v4/contents/language-content';
var CLIENT_TIMEOUT = 7000;

var LandingPagesAPI =
/*#__PURE__*/
function () {
  function LandingPagesAPI() {
    (0, _classCallCheck2.default)(this, LandingPagesAPI);
  }

  (0, _createClass2.default)(LandingPagesAPI, null, [{
    key: "getByIds",
    value: function getByIds(_ref) {
      var ids = _ref.ids;
      return _apiClient.default.get(BASE_URL, {
        query: {
          clienttimeout: CLIENT_TIMEOUT,
          id__in: ids.join(','),
          limit: ids.length
        }
      });
    }
  }, {
    key: "getByNameQuery",
    value: function getByNameQuery(_ref2) {
      var nameQuery = _ref2.nameQuery;
      return _apiClient.default.get(BASE_URL, {
        query: {
          clienttimeout: CLIENT_TIMEOUT,
          limit: 20,
          name__icontains: nameQuery,
          subcategory__in: ['landing_page', 'site_page']
        }
      });
    }
  }, {
    key: "getByLanguageContent",
    value: function getByLanguageContent(_ref3) {
      var domain = _ref3.domain,
          language = _ref3.language;
      return _apiClient.default.get(LANGUAGE_CONTENT_URL, {
        query: {
          domain: domain,
          language: language
        }
      });
    }
  }, {
    key: "updateLandingPage",
    value: function updateLandingPage(data) {
      return _apiClient.default.put(BASE_URL + "/" + data.id, {
        data: data
      });
    }
  }]);
  return LandingPagesAPI;
}();

exports.default = LandingPagesAPI;
module.exports = exports.default;